import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { OrganizationDetailsProps } from './OrganizationDetails';

export const LazyOrganizationDetails: FunctionComponent<
  OrganizationDetailsProps
> = (props) => {
  const OrganizationDetails = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "organization-details" */ './OrganizationDetails'
      ),
    { namedImport: 'OrganizationDetails' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Team Profile Header',
      }}
    >
      <Suspense fallback={null}>
        <OrganizationDetails {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
